/* global document */

import ReactDOM from 'react-dom';

import LoginForm from 'profile/login/LoginForm';

const LoginFormWidget = (props) => {
  const { redirectTo } = props;

  return ReactDOM.createPortal(
    <LoginForm redirectTo={redirectTo} />,
    document.getElementById('c7-login-form')
  );
};

export default LoginFormWidget;
